export default __webpack_public_path__ + "static/media/D2L.d1d456d4.png";